import React from 'react';
import styles from './Programs.module.css';

function Programs() {
  return (
    <section className={styles.programs}>
      <h2>Programs & Curriculum</h2>
      <ul className={styles.list}>
        <li>Following South Sudan curriculum</li>
        <li>Baby class to Primary Eight (P8)</li>
      </ul>
      <div>
        <span className={styles.label}>School Colors:</span> 
        <span className={styles.colors}>
          <span className={styles.grey}></span>
          <span className={styles.white}></span>
          <span className={styles.red}></span>
          <span className={styles.yellow}></span>
        </span>
        <span className={styles.colorNames}>Grey, White, Red, Yellow</span>
      </div>
    </section>
  );
}

export default Programs;
